import React from "react";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import styles from './EarnCertificate.module.css';
import Buttons from '../Button/Button';
import Certificate from '../../assets/imgs/earn-certificate-from-the-comfort of-your-home.png';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Image from "next/image";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div p={1}>
          {/* p tag has issues wrapping div tags with NextJS */}
          <div>{children}</div>
        </div>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function EarnCertificate(props) {


  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  return (
    <div className="Section">
      <Container maxWidth="lg">
        <div className={styles.EarnCertificate}>

          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={6}>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <div className={`${styles.TabContainer} ${styles.CertificateTab}`}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                  <Tab label={<p>Diploma</p>} {...a11yProps(0)} />
                  <Tab label={<p>Certificate</p>} {...a11yProps(1)} />

                </Tabs>
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <div className={styles.CertificateDetails}>
                <TabPanel value={value} index={0}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={6}>
                      <div className={styles.Certificate}><Image src={Certificate} /></div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <div className={styles.CertificateInfo}>
                        <h1>Diploma and graduation tracks</h1>
                        <h2>Earn certificate from the comfort of your home</h2>
                        <p>Your future career starts here. Study online, with flexible payment options and the full support of industry pros and career mentors.</p>
                        <li>Add the certificate in your CV</li>
                        <li>Share the certificate on your LinkedIn profile</li>
                        <li>Share this certificate on your Facebook by one click</li>
                        <li>Add the certificate in your CV</li>
                        <Buttons
                          label="Explore Certificate Courses"
                          buttonColor="#FFAE35"
                          color="#261E7D"
                          width="auto"
                          height="48px"
                          fontSize="14px"
                          border="#FFAE35 1px solid"
                        />
                      </div>
                    </Grid>
                  </Grid>
                </TabPanel>

                <TabPanel value={value} index={1}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={6}>
                      <div className={styles.Certificate}><Image src={Certificate} /></div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                    <div className={styles.CertificateInfo}>
                    <h1>Certificate and graduation tracks</h1>
                    <h2>Earn certificate from the comfort of your home</h2>
                    <p>Your future career starts here. Study online, with flexible payment options and the full support of industry pros and career mentors.</p>
                    <li>Add the certificate in your CV</li>
                    <li>Share the certificate on your LinkedIn profile</li>
                    <li>Share this certificate on your Facebook by one click</li>
                    <li>Add the certificate in your CV</li>
                    <Buttons
                      label="Explore Certificate Courses"
                      buttonColor="#FFAE35"
                      color="#261E7D"
                      width="auto"
                      height="48px"
                      fontSize="14px"
                      border="#FFAE35 1px solid"
                      link=""
                    />
                  </div>
                    </Grid>
                  </Grid>
                </TabPanel>

              </div>
            </Grid>

          </Grid>

        </div>
      </Container>

    </div>
  );
}



export default EarnCertificate
